<template>
	<search-bar
		class="promo-search-bar"
		:ctas="ctas"
		:show-geo-location="true"
		@browse="compare()"/>
</template>

<script>
export default {
	methods: {
		compare() {
			this.$scrollTo('.packages');
		}
	},
	data() {
		return {
			ctas: [
				{
					label: 'Promotion details',
					cssClass: 'btn secondary',
					event: 'browse'
				},
				{
					label: 'Check Coverage',
					cssClass: 'btn primary',
					event: 'checkCoverage'
				},
			],
		}
	},
	mounted() {
		if(this.$store && window._providers) {
			this.$store.commit('providers/updateProviders', window._providers);
		}
	}
}
</script>

<style lang="scss">
	.promo-search-bar {
		max-width: 74rem;
		margin-top: 3rem;
		margin-bottom: 3.5rem;

		.search-bar-ctas {
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;

			button {
				max-width: 23rem;
				width: 100%;
				padding: 0.5rem 0;
				border-radius: 2.8rem;
				//height: 4.6rem;

				display: inline-block;
				line-height: 3.6rem;
				font-size: 1rem;
				font-weight: bold;
				color: #fff;
				text-transform: uppercase;
				border: none;
				outline: none;
				text-align: center;

				&:nth-child(2) {
					margin-left: 2rem;
				}

				&.primary {
					background: #34BACD;
				}

				&.secondary {
					background-color: transparent;
					border: 0.1rem solid;
				}
			}
		}
	}
</style>
